import TaskService from '../../../services/task.service'

// The backend has returned the spent time under several names over time, so
// every reader has to look at all of them.
export const TASK_SPENT_TIME_FIELDS = [
    'spendTime',
    'spend_time',
    'time_spent',
    'tracked_time',
    'time_tracking',
]

const TASK_TIME_FIELDS = [
    ...TASK_SPENT_TIME_FIELDS,
    'timeLogId',
    'time_log_id',
    'timeLogDescription',
    'time_log_description',
    'totalTimeSpent',
    'total_time_spent',
    'deletedRelatedTaskIds',
]

export function stripTaskTimeTrackingFields(task: any) {
    const nextTask = { ...(task || {}) }

    TASK_TIME_FIELDS.forEach((field) => {
        delete nextTask[field]
    })

    return nextTask
}

export function buildTaskUpdatePayload(
    task: any,
    projectId: number,
    overrides: Record<string, any> = {}
) {
    return stripTaskTimeTrackingFields({
        title: task.title || '',
        description: task.description || '',
        status: task.status || '',
        priority: task.priority || '',
        task_type: task.task_type || 'task',
        project_id: task.project_id || projectId,
        ...(task.parent_id != null ? { parent_id: task.parent_id } : {}),
        assignee_ids: Array.isArray(task.assignee_ids) ? task.assignee_ids : [],
        due_date: task.due_date || null,
        ...overrides,
    })
}

// The task API uses PUT. Merge only the fields touched by this editor into a
// fresh task before sending it, so an old open modal cannot overwrite a
// colleague's newer values in unrelated fields.
export async function updateTaskChangedFields(
    taskId: number,
    projectId: number,
    changes: Record<string, any>,
) {
    if (!Object.keys(changes).length) return null

    const latest = await TaskService.get(taskId)
    const hasChange = Object.entries(changes).some(([key, value]) => (
        JSON.stringify(latest?.[key]) !== JSON.stringify(value)
    ))
    if (!hasChange) return latest

    return TaskService.update(taskId, buildTaskUpdatePayload(latest, projectId, changes))
}
